import { useNavigate } from "react-router-dom";

import Style from "./style";

import MainHeader from "widget/MainHeader";
import Search from "widget/Search"
import Pagenation from "widget/Pagenation";

import TStyle from "shared/style/tableStyle";
import TableLoading from "shared/ui/TableLoading"
import useGetSeedTicketLog from "entity/ticket/useGetSeedTicketLog";
import timestampCalculator from "shared/lib/timestampCalculator"
import { convertTicketTypeAsName } from "shared/constant/lookup/ticketType";
/**
 * @Desc 시드권 발급 기록 Page
 * @Access 없음
 *
 */
const SeedTicketLog = () => {
  const navigate = useNavigate();
  const [seedTicketLogList, isLoading] = useGetSeedTicketLog()

  const sizeList = ["short", "long", "medium", "expand", "expand", "expand", "short", "long", "medium"]
  const tableHeadList = [
    { label: "ID", sortKey: "accountid" },
    { label: "이름", sortKey: "accountname" },
    { label: "연락처", sortKey: "accountcontact" },
    { label: "시드권 이름", sortKey: "ticketname" },
    { label: "시리즈명", sortKey: "seriesname" },
    { label: "대회명", sortKey: "eventname" },
    { label: "발급 갯수", sortKey: "issuecount" },
    { label: "발급 일자", sortKey: "issuedat" },
    { label: "상태", sortKey: "tickettype" },
  ]

  return (
    <Style.Wrapper>
      <MainHeader>시드권 발급 기록</MainHeader>
      <Search 
        placeholder="연락처 또는 이름을 입력해주세요"
        seedTicketNameFilter={true}
        seriesNameFilter={true}
        eventNameFilter={true}
      />

      <TableLoading isLoading={isLoading}>
        <TStyle.TableDiv>
          <TStyle.TableInner>
            <TStyle.TableRow $title>
              {tableHeadList.map((elem, index) => (
                <TStyle.Data key={index} $title $size={sizeList[index]}>
                  {elem.label}
                </TStyle.Data>
              ))}
            </TStyle.TableRow>
            {seedTicketLogList?.data?.items?.map((seed, index) => (
              <TStyle.TableRow
                key={index}
                $odd={index % 2 === 1}
                onClick={() => navigate(`/user/${seed?.accountid}/detail`)}
              >
                <TStyle.Data $size={sizeList[0]}>{seed?.accountid}</TStyle.Data>
                <TStyle.Data $size={sizeList[1]}>{seed.accountname}</TStyle.Data>
                <TStyle.Data $size={sizeList[2]}>
                  {seed.accountcontact}
                </TStyle.Data>
                <TStyle.Data $size={sizeList[3]}>{seed?.ticketname}</TStyle.Data>
                <TStyle.Data $size={sizeList[4]}>{seed?.seriesname}</TStyle.Data>
                <TStyle.Data $size={sizeList[5]}>{seed?.eventname}</TStyle.Data>
                <TStyle.Data $size={sizeList[6]}>{seed?.issuecount}</TStyle.Data>
                <TStyle.Data $size={sizeList[7]}>{timestampCalculator(seed?.issuedat)}</TStyle.Data>
                <TStyle.Data $size={sizeList[8]}>{convertTicketTypeAsName[seed?.tickettype]}</TStyle.Data>
              </TStyle.TableRow>
            ))}
          </TStyle.TableInner>
        </TStyle.TableDiv>
      </TableLoading>

      <Pagenation maxPage={seedTicketLogList?.data?.max_page} />
    </Style.Wrapper>
  );
};

export default SeedTicketLog;
